import type { Locale } from '@skyground/contracts'
import { createContext, useContext } from 'react'

/** The locale state the auth screen reads and drives — the shape the shared `LocalePort` expects. */
export interface I18nContextType {
  initLocale: Locale
  locale: Locale
  setLocale: (locale: Locale) => void
}

export const I18nContext = createContext<I18nContextType | null>(null)

/** Read the active locale and switcher. Throws outside an {@link I18nProvider} so misuse is loud. */
export const useI18n = (): I18nContextType => {
  const context = useContext(I18nContext)

  if (!context) {
    throw new Error('useI18n must be used within an I18nProvider')
  }

  return context
}
